import React from 'react';
import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import * as ds from './dataService';


export type SelectPrecipitationTypeFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};

export const FC = <T extends object>(props: SelectPrecipitationTypeFieldProps<T>) => {

  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
    />
  );
};
